module.exports = __webpack_public_path__ + "img/vip3.43a2cff6.png";